import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctor } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../config/api.config';
import {
  CLINIC_ADDRESS,
  CLINIC_EMAIL,
  CLINIC_PHONE,
  CLINIC_PHONE_TEL,
  DEFAULT_DOCTOR_DETAILS,
} from '../config/clinic.config';
import BackButton from './BackButton';
import './DoctorConsultation.css';

const About = ({ onBackClick }) => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}?action=doctors`);
        const data = await response.json();
        if (data.status === 'ok') {
          setDoctors(data.doctors || []);
        }
      } catch (err) {
        console.error('Error fetching doctors:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDoctors();
  }, []);

  const detailLines = (details) => {
    const text = (details || DEFAULT_DOCTOR_DETAILS).trim();
    return text.split(/\r?\n/).filter(Boolean);
  };

  return (
    <div className="about-section">
      {onBackClick && <BackButton onClick={onBackClick} />}
      <div className="about-container">
        <h2>About AlamCareRx</h2>

        <div className="about-pharmacy">
          <h3>About Our Pharmacy</h3>
          <p>
            AlamCareRx is a leading online pharmacy dedicated to providing convenient access to quality medicines
            and healthcare products. We prioritize customer health and satisfaction above all else.
          </p>
          <ul>
            <li>✓ Licensed and certified pharmacists</li>
            <li>✓ Fast and reliable delivery</li>
            <li>✓ Authentic medicines only</li>
            <li>✓ 24/7 customer support</li>
          </ul>
        </div>

        <div className="about-doctors">
          <h3>Our Healthcare Professionals</h3>
          {loading ? (
            <p className="doctor-loading">Loading doctors...</p>
          ) : doctors.length === 0 ? (
            <p className="doctor-empty">No doctors are available at the moment.</p>
          ) : (
            <div className="doctor-profiles">
              {doctors.map((doctor) => {
                const phone = doctor.phone || CLINIC_PHONE;
                return (
                  <div key={doctor.id} className="doctor-profile">
                    <div className="doctor-avatar doctor-profile-avatar">
                      <FontAwesomeIcon icon={faUserDoctor} />
                    </div>
                    <h4>{doctor.name}</h4>
                    {detailLines(doctor.details).map((line) => (
                      <p key={line}>{line}</p>
                    ))}
                    <p>
                      Phone:{' '}
                      <a href={`tel:${phone.replace(/[^\d+]/g, '') || CLINIC_PHONE_TEL}`}>{phone}</a>
                    </p>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="contact-info">
          <h3>Contact Information</h3>
          <p>
            Email: <a href={`mailto:${CLINIC_EMAIL}`}>{CLINIC_EMAIL}</a>
          </p>
          <p>
            Phone: <a href={`tel:${CLINIC_PHONE_TEL}`}>{CLINIC_PHONE}</a>
          </p>
          <p>Address: {CLINIC_ADDRESS}</p>
        </div>
      </div>
    </div>
  );
};

export default About;
